import React from "react"

export default class Footer extends React.Component {
  render() {
    return (
      <footer className="modern-footer">
        <div className="container">
          <div className="footer-content">
            {/* Logo and Location Section */}
            <div className="footer-brand">
              <div className="footer-logo">
              <img src="/static/misago/img/tbdLogo.svg" alt="TBD Logo" />
              </div>
              <div className="footer-location">
                {/* Baluwatar, Kathmandu, Nepal */}
              </div>
            </div>

            {/* Links Sections */}
            <div className="footer-links">
              {/* Company Section */}
              {/* <div className="footer-section">
                <h4 className="footer-section-title">Company</h4>
                <ul className="footer-section-links">
                  <li><a href="https://thebuildingdecision.com/about-us">TBD</a></li>
                  <li><a href="#">Branding</a></li>
                  <li><a href="#">Campaigns</a></li>
                  <li><a href="#">Offline</a></li>
                </ul>
              </div> */}

              {/* About Section */}
              <div className="footer-section">
                <h4 className="footer-section-title">About</h4>
                <ul className="footer-section-links">
                  <li><a href="https://thebuildingdecision.com/about-us">Our story</a></li>
                  {/* <li><a href="#">Benefits</a></li>
                  <li><a href="#">Team</a></li> */}
                </ul>
              </div>

              {/* Help Section */}
              <div className="footer-section">
                <h4 className="footer-section-title">Help</h4>
                <ul className="footer-section-links">
                  <li><a href="https://thebuildingdecision.com/faq">FAQ</a></li>
                  <li><a href="https://thebuildingdecision.com/contact-us">Contact Us</a></li>
                </ul>
              </div>
            </div>
          </div>

          {/* Footer Bottom */}
          <div className="footer-bottom">
            <div className="footer-bottom-content">
              <div className="copyright">
                © 2077 The Building Decision. All rights reserved.
              </div>
              <div className="footer-legal">
                <a href="https://thebuildingdecision.com/privacy-policy">Privacy policy</a>
                <a href="https://thebuildingdecision.com/terms-and-conditions">Terms & Conditions</a>
              </div>
              <div className="footer-social">
                <a href="#" className="social-link" aria-label="Facebook">
                 <img src="/static/misago/img/fblogo.svg" alt="Facebook Logo" />
                </a>
                <a href="#" className="social-link" aria-label="Twitter">
                 <img src="/static/misago/img/xlogo.svg" alt="Twitter Logo" />
                </a>
                <a href="#" className="social-link" aria-label="Instagram">
                 <img src="/static/misago/img/intalogo.svg" alt="Instagram Logo" />
                </a>
               
              </div>
            </div>
          </div>
        </div>
      </footer>
    )
  }
}